import * as actionTypes from "../actions/actionTypes";
import * as actionHandler from "../actions/clientDashboardActions";
import moment from "moment-timezone";

const initialState = {
  selected: 0,
  timePeriod: 1,
  userProfileUrl: null,
  startDate: moment().clone().subtract(7, 'days').utc().startOf('day').unix() * 1000,
  showDropdown: false,
  map: null,
  updateCampaign: false,
  campaignVehiclesPath: [],
  analytics: {
    vehicleCount: 0,
    totalMilesDriven: 0,
    totalImpressions: 0
  },
  campaigns: {
    "0": {
      name: "",
      boundingBox: [],
      vehicles: {}
    }
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_SELECTED:
      return actionHandler.updateSelected(state, action);
      case actionTypes.UPDATE_CAMPAIGN_VEHICLES_MAPBOX:
        return actionHandler.updateCampaignVehiclesMapBox(state, action);
      case actionTypes.UPDATE_PROFILE:
        return actionHandler.updateProfile(state, action);
    case actionTypes.UPDATE_START_DATE:
      return actionHandler.updateStartDate(state, action);
    case actionTypes.UPDATE_ANALYTICS:
      return actionHandler.updateAnalytics(state, action);
    case actionTypes.TOGGLE_DROPDOWN:
      return actionHandler.toggleDropdown(state, action);
    case actionTypes.LOAD_CLIENT_CAMPAIGNS:
      return actionHandler.loadClientCampaigns(state, action);
    case actionTypes.SET_BOXI_MAP:
      return actionHandler.setBoxiMap(state, action);
    case actionTypes.UPDATE_CAMPAIGN_VEHICLES:
      return actionHandler.updateCampaignVehicles(state, action);
    default:
      return state;
  }
};

export default reducer;
